import React from "react";
import {Typography} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {useGetNFLPlayerSeasonStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";

import "../SeasonStats.style.scss";
const renderQuarterBackSeasonStats = (data) => {
    return <div className="seasonStats">
        <div className="statItem">
            <div>{data.GamesPlayed}</div>
            <div>GP</div>
        </div>
        <div className="statItem">
            <div>{data.PassingYards}</div>
            <div>YDS</div>
        </div>
        <div className="statItem">
            <div>{data.Touchdowns}</div>
            <div>TD</div>
        </div>
        <div className="statItem">
            <div>{data.Interceptions}</div>
            <div>INT</div>
        </div>
        <div className="statItem">
            <div>{data.PasserRating}</div>
            <div>RAT</div>
        </div>
        <div className="statItem">
            <div>{data.TotalTouchownsPG}</div>
            <div>TTD/GM</div>
        </div>
    </div>
}

const renderRunningBackSeasonStats = (data) => {
    return <div className="seasonStats">
        <div className="statItem">
            <div>{data.GamesPlayed}</div>
            <div>GP</div>
        </div>
        <div className="statItem">
            <div>{data.Carries}</div>
            <div>CAR</div>
        </div>
        <div className="statItem">
            <div>{data.PassingYards}</div>
            <div>YDS</div>
        </div>
        <div className="statItem">
            <div>{data.AverageYards}</div> // Average Yards Per Carry
            <div>AVG</div>
        </div>
        <div className="statItem">
            <div>{data.Touchdowns}</div>
            <div>TD</div>
        </div>
        <div className="statItem">
            <div>{data.TotalTouchownsPG}</div>
            <div>TTD/GM</div>
        </div>
    </div>
}

const renderReceiverSeasonStats = (data) => {
    return <div className="seasonStats">
        <div className="statItem">
            <div>{data.GamesPlayed}</div>
            <div>GP</div>
        </div>
        <div className="statItem">
            <div>{data.Receptions}</div>
            <div>REC</div>
        </div>
        <div className="statItem">
            <div>{data.ReceivingYards}</div>
            <div>YDS</div>
        </div>
        <div className="statItem">
            <div>{data.AverageYards}</div> // Average Yards Per Reception
            <div>AVG</div>
        </div>
        <div className="statItem">
            <div>{data.Touchdowns}</div>
            <div>TD</div>
        </div>
        <div className="statItem">
            <div>{data.TotalTouchownsPG}</div>
            <div>TTD/GM</div>
        </div>
    </div>
}

const NFLSeasonStats = ({player, seasonYears}) => {
    const {data} = useGetNFLPlayerSeasonStatsByPlayerIdQuery({playerId: player.PlayerId, seasonYears: seasonYears[0]});

    let content = null;

    switch (player.Position) {
        case "QB":
            content = renderQuarterBackSeasonStats(data);
            break;
        case "WR":
            content = renderReceiverSeasonStats(data);
            break;
        case "RB":
            content = renderRunningBackSeasonStats(data);
            break;
        default:
            content = renderReceiverSeasonStats(data);
    }

    return <div className="NFLSeasonStats">
        <Typography variant="h6" className="gameLogTitle">
            {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.seasonStats"}/>
        </Typography>
        {content}
    </div>
}

export default NFLSeasonStats;